import axios from '../axios';

/**
 * Authentication API - כל הפונקציות הקשורות להתחברות ומשתמשים
 */

export const authApi = {
  // הרשמה
  signup: async (userData) => {
    try {
      const response = await axios.post('/auth/signup', userData);
      return response.data;
    } catch (error) {
      console.error('Error during signup:', error);
      throw error;
    }
  },

  // התחברות
  login: async (credentials) => {
    try {
      const response = await axios.post('/auth/login', credentials);
      return response.data;
    } catch (error) {
      console.error('Error during login:', error);
      throw error;
    }
  },

  // התנתקות
  logout: async () => {
    try {
      const response = await axios.post('/auth/logout');
      return response.data;
    } catch (error) {
      console.error('Error during logout:', error);
      throw error;
    }
  },

  // בדיקת מצב התחברות
  checkAuth: async () => {
    try {
      const response = await axios.get('/auth/profile');
      return response.data;
    } catch (error) {
      console.error('Error checking auth status:', error);
      throw error;
    }
  },

  // עדכון פרופיל משתמש
  updateProfile: async (profileData) => {
    try {
      const response = await axios.put('/auth/profile', profileData);
      return response.data;
    } catch (error) {
      console.error('Error updating profile:', error);
      throw error;
    }
  },

  // איפוס סיסמה - שליחת אימייל
  forgotPassword: async (email) => {
    try {
      const response = await axios.post('/auth/forgot-password', { email });
      return response.data;
    } catch (error) {
      console.error('Error sending forgot password email:', error);
      throw error;
    }
  },

  // איפוס סיסמה - קביעת סיסמה חדשה
  resetPassword: async (token, newPassword) => {
    try {
      const response = await axios.post('/auth/reset-password', { 
        token, 
        password: newPassword 
      });
      return response.data;
    } catch (error) {
      console.error('Error resetting password:', error);
      throw error;
    }
  },

  // רענון טוקן
  refreshToken: async () => {
    try {
      const response = await axios.post('/auth/refresh-token');
      return response.data;
    } catch (error) {
      console.error('Error refreshing token:', error);
      throw error;
    }
  },

  // Admin functions
  admin: {
    // קבלת כל המשתמשים (admin only)
    getAllUsers: async () => {
      try {
        const response = await axios.get('/admin/users');
        return response.data;
      } catch (error) {
        console.error('Error fetching all users:', error);
        throw error;
      }
    },

    // קבלת כל הסשנים (admin only)
    getAllSessions: async () => {
      try {
        const response = await axios.get('/admin/sessions');
        return response.data;
      } catch (error) {
        console.error('Error fetching sessions:', error);
        throw error;
      }
    },

    // קבלת לוגי אודיט (admin only)
    getAuditLogs: async () => {
      try {
        const response = await axios.get('/admin/audit-logs');
        return response.data;
      } catch (error) {
        console.error('Error fetching audit logs:', error);
        throw error;
      }
    },

    // יצירת משתמש חדש (admin only)
    createUser: async (userData) => {
      try {
        const response = await axios.post('/admin/users', userData);
        return response.data;
      } catch (error) {
        console.error('Error creating user:', error);
        throw error;
      }
    },

    // מחיקת משתמש (admin only)
    deleteUser: async (userId) => {
      try {
        const response = await axios.delete(`/admin/users/${userId}`);
        return response.data;
      } catch (error) {
        console.error('Error deleting user:', error);
        throw error;
      }
    },

    // עדכון תפקיד משתמש (admin only)
    updateUserRole: async (userId, role) => {
      try {
        const response = await axios.patch(`/admin/users/${userId}/role`, { role });
        return response.data;
      } catch (error) {
        console.error('Error updating user role:', error);
        throw error;
      }
    },

    // מחיקת סשן (admin only)
    deleteSession: async (sessionId) => {
      try {
        const response = await axios.delete(`/admin/sessions/${sessionId}`);
        return response.data;
      } catch (error) {
        console.error('Error deleting session:', error);
        throw error;
      }
    }
  }
};

export default authApi; 